import React, { useEffect, useState } from "react";
import brand from "../brand";

const getNextDraw = () => {
  const now = new Date();
  const candidates = brand.drawTimes.map((draw) => {
    const target = new Date(now);
    target.setHours(draw.releaseHour, 0, 0, 0);
    if (target <= now) {
      target.setDate(target.getDate() + 1);
    }
    return { ...draw, target };
  });

  return candidates.sort((a, b) => a.target - b.target)[0];
};

const splitTime = (distance) => {
  const totalSeconds = Math.max(0, Math.floor(distance / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds].map((value) => String(value).padStart(2, "0"));
};

const CountdownTimer = ({ compact = false }) => {
  const [now, setNow] = useState(Date.now());
  const nextDraw = getNextDraw();
  const [hours, minutes, seconds] = splitTime(nextDraw.target.getTime() - now);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className={`countdown ${compact ? "countdown-compact" : ""}`}>
      <span className="countdown-label">Next {nextDraw.label}</span>
      <span className="countdown-time">
        {hours}:{minutes}:{seconds}
      </span>
    </div>
  );
};

export default CountdownTimer;
